import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { HelperWrapper, MainContainer, QRCodePaper } from 'src/components'

import { ROUTES } from 'src/constants/app-keys.const'
import { joinAbsRoute } from 'src/common/utils'
import { useProduct } from 'src/hooks'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'

const ProductQRCodeScreen = () => {
  const [t] = useTranslation()
  const { id, accountId } = useParams()
  const { data, isLoading } = useProduct(DEFAULT_LANGUAGE_CODE)

  if (isLoading || !data) {
    return null
  }

  return (
    <MainContainer
      headerTitle={<HelperWrapper t="qr-code-header-title" />}
      headerDescr={data.name}
      headerCode={`#${data.code}`}
      navigateBack
      withAccountIcon
      withScanBtn
    >
      <QRCodePaper
        route={joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.PRODUCTS, id)}
        batchCode={`#${data.code}`}
        code={`#${data.code}`}
        name={data.name}
        title={t('qr-code-subtitle.v')}
        productId={data.id}
      />
    </MainContainer>
  )
}

export default ProductQRCodeScreen
